/** The console «Prove» page (atlas chapter 489). Twin: `it.ts`. */
export default {
  titolo: 'Demos',
  sottotitolo: 'Phone assistant and chatbot for interested companies to try, without using the numbers of client companies.',
  aggiorna: 'Refresh',
  azienda: {
    non_impostata: 'The demo company is not set yet: until then you cannot create demos or links.',
    non_pronta: 'Links do not work yet: {{motivo}}.',
    pronta: '{{nome}} answers on {{numero}}.',
  },
  elenco: {
    titolo: 'Demos',
    nuova: 'New demo',
    vuoto: 'No demos yet. Create one to send your first link.',
    prova: 'Demo',
    prodotto: 'Product',
    stato: 'Status',
    lo_chiede_l_assistente: 'The assistant asks',
    pronta: 'Ready',
    crea_link: 'Create link',
    modifica: 'Edit',
  },
  inviti: {
    titolo: 'Links created',
    vuoto: 'No links created.',
    per_chi: 'For',
    senza_nome: 'No name',
    prova: 'Demo',
    scade: 'Expires',
    usato: 'Used',
    usi: '{{usi}} of {{massimo}}',
    usi_pubblico: '{{usi}}',
    stato: 'Status',
    prova_eliminata: 'Demo deleted',
    copia: 'Copy link',
    revoca: 'Revoke',
    stati: {
      attivo: 'Active',
      scaduto: 'Expired',
      usi_esauriti: 'No uses left',
    },
  },
  dialogo_prova: {
    titolo_nuova: 'New demo',
    titolo_modifica: 'Edit demo',
    etichetta: 'Demo name',
    descrizione: 'What it lets people try',
    missione: 'Mission',
    categoria: 'Product',
    categoria_aiuto: 'With a product chosen, the assistant does not ask for it.',
    messaggio: 'Pre-written message',
    messaggio_aiuto: 'The person sends it by tapping the link.',
    attiva: 'Active',
    salva: 'Save demo',
    annulla: 'Cancel',
  },
  dialogo_invito: {
    titolo: 'Create link: {{prova}}',
    nome: 'For (optional)',
    giorni: 'Valid for how many days',
    pubblico: 'Link for the website: anyone can use it, until you revoke it',
    crea: 'Create link',
    annulla: 'Cancel',
    chiudi: 'Close',
    pronto: 'Tapping the link opens WhatsApp with the message already written. It expires on {{giorno}}.',
    qr: 'QR code of the link',
    copia: 'Copy link',
  },
  dialogo_revoca: {
    titolo: 'Revoke this link?',
    testo: 'From now on, whoever taps it talks to the assistant without starting this demo. This cannot be undone.',
    conferma: 'Revoke link',
    annulla: 'Cancel',
  },
  messaggi: {
    prova_salvata: 'Demo saved',
    link_copiato: 'Link copied',
    link_revocato: 'Link revoked',
    copia_non_riuscita: 'The browser did not copy the link: select it and copy it by hand.',
    errore_generico: 'The server did not respond. Try again shortly: if it continues, its log needs checking.',
  },
  motivi: {
    whatsapp_spento: 'WhatsApp is not active on the demo company',
    numero_non_collegato: 'the demo company has no WhatsApp number connected',
    agente_spento: 'the demo company\'s assistant is off',
    missione_spenta: 'the mission is off on the demo company',
    prova_spenta: 'the demo is off',
    missione_non_valida: 'this mission cannot start from a link',
    categoria_non_valida: 'the demo company does not sell this product',
    azienda_non_impostata: 'the demo company is not set',
    prova_non_trovata: 'this demo no longer exists',
    campi_mancanti: 'the demo name and the message are required',
    invito_non_trovato: 'this link no longer exists',
  },
} as const;
